import React from 'react';
import { Trash2 } from 'lucide-react';
import './BoardEditModal.css';

/**
 * Footer of the create / edit board modal (card 5.1): "Delete board" on the
 * left (edit mode only — it hands over to the usual confirm dialog, it never
 * deletes on its own), Cancel and the primary action on the right.
 */
export default function BoardEditFooter({ mode, canSubmit, onCancel, onSubmit, onDelete }) {
  return (
    <div className="board-edit-footer">
      {onDelete ? (
        <button type="button" className="board-edit-delete" onClick={onDelete}>
          <Trash2 size={13} aria-hidden />
          Delete board
        </button>
      ) : (
        <span />
      )}
      <div className="board-edit-footer-actions">
        <button type="button" className="board-edit-btn board-edit-btn--secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="board-edit-btn board-edit-btn--primary" onClick={onSubmit} disabled={!canSubmit}>
          {mode === 'create' ? 'Create' : 'Update'}
        </button>
      </div>
    </div>
  );
}
